module.exports = __webpack_public_path__ + "static/img/validCode6.1d61f66.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/validCode/validCode6.jpg
// module id = X0A0
// module chunks = 4 5 6 8 9 10 11